module.exports = __webpack_public_path__ + "static/img/KK-3.a7a03b45.png";